import React, { createContext, useContext, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingPage from '../Pages/LoadingPage';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);

  console.log("auth", auth)

  useEffect(() => {
    setAuth(!!localStorage.getItem("autoChef_authToken"));
  }, []);
  console.log("Auth Called");

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {auth === null ? <LoadingPage /> : children}
    </AuthContext.Provider>
  );
};

export const ProtectedRoute = ({ children }) => {
  const { auth } = useAuth();

  if (auth === null) {
    return <LoadingPage />;
  } else if (!auth) {
    return <Navigate to="/login" />;
  } else {
    return children;
  }
};
